export default __webpack_public_path__ + "static/loans-e552d535b03ab14aebb515152e1ec345.webp";